const BASE_URL = process.env.REACT_APP_BASE_URL || '';

export async function fetchWithAuth(pathOrUrl, options = {}) {
  const token = localStorage.getItem('token');
  const headers = options.headers ? { ...options.headers } : {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const url = typeof pathOrUrl === 'string' && (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://'))
    ? pathOrUrl
    : `${BASE_URL}${pathOrUrl}`;

  const res = await fetch(url, { ...options, headers });
  return res;
}

export default fetchWithAuth;
